import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  deviceContainer: {
    width: "100%",
    marginTop: "20px"
  }
}));

export { useStyles };